import { MutableRefObject } from 'react';
import { Box } from '@chakra-ui/react';
import { Formik, Form, FormikProps } from 'formik';
import { SectionLabel } from '@kula-ai/components';
import { KText } from '@/ui-library/components/text';
import { FormEditor } from '@/components/formBuilder/formFields/FormEditor';
import { SCHEDULE_AI_COPY } from '../../constants';

const COPY = SCHEDULE_AI_COPY;

type AdditionalContextValues = { additional_context: string };

type AdditionalContextSectionProps = {
  additionalContextFormikRef: MutableRefObject<FormikProps<AdditionalContextValues> | null>;
  initialAdditionalContext?: string;
};

export const AdditionalContextSection = ({
  additionalContextFormikRef,
  initialAdditionalContext = '',
}: AdditionalContextSectionProps) => (
  <Box mb="20px">
    <SectionLabel>{COPY.additionalContextLabel}</SectionLabel>
    <KText fontSize="14px" color="#6D659D" lineHeight="20px" mt="8px" mb="10px">
      {COPY.additionalContextDescription}
    </KText>
    <Box
      border="1px solid"
      borderColor="#E9EBF4"
      borderRadius="8px"
      overflow="hidden"
    >
      <Formik<AdditionalContextValues>
        initialValues={{ additional_context: initialAdditionalContext }}
        enableReinitialize
        onSubmit={() => {}}
      >
        {(formik) => {
          additionalContextFormikRef.current = formik;
          return (
            <Form>
              <FormEditor
                item={{
                  name: 'additional_context',
                  placeholder: COPY.additionalContextPlaceholder,
                  editorContainerStyles: {
                    border: 'none',
                    borderRadius: '0',
                    minHeight: '120px',
                  },
                  editorStyles: {
                    minHeight: '100px',
                    padding: '8px 12px',
                    fontSize: '14px',
                  },
                  contentType: 'html',
                }}
                field={{
                  name: 'additional_context',
                  value: formik.values.additional_context || '',
                }}
                formik={formik}
              />
            </Form>
          );
        }}
      </Formik>
    </Box>
  </Box>
);
